













































import { Component, Prop, Vue } from 'vue-property-decorator'
import DigitalPost from '@/apiClient/DigitalPost'

@Component({
  name: 'BillboardFileViewer'
})

export default class BillboardFileViewer extends Vue {
  @Prop() public id!: string;
  @Prop() public type: string;
  @Prop() public changeFile: boolean;

  @Prop() public width: number;
  @Prop() public height: number;

  public readonly DEFAULT_WIDTH  = 600;
  public readonly DEFAULT_HEIGHT = 500;

  pdf: any;
  pages: number;
  rotation: number;
  loading: boolean;
  show: boolean;
  image: string;
  errorImg: boolean;
  errorPdf: boolean;
  pdfLoaded: boolean;
  totalsPages: number;
  curPage: number;

  digitalPost: DigitalPost;

  @Prop() public fileForPreview: any;

  data() {
    return {
      pdf: '',
      pages: 0,
      loading: false,
      show: true,
      image: '',
      errorImg: false,
      errorPdf: false,
      rotation: 0,
      pdfLoaded: false,
      totalsPages: 0,
      curPage: 1
    }
  }

  async created() {
    this.digitalPost = new DigitalPost()
    await this.getFile()
    this.$watch(() => (
      {
        changeFile: this.changeFile,
        fileForPreview: this.fileForPreview
      }
    ),
() => this.getFile())
  }

  get getFilePreviewHeight() {
    if (this.type === 'pdf') return '421.5px'
    return (this.height) ? `${this.height}px` : `${this.DEFAULT_HEIGHT}px`;
  }

  get getFilePreviewWidth() {
    if (this.type === 'pdf') return '297.5px'
    return (this.width) ? `${this.width}px` : `${this.DEFAULT_WIDTH}px`;
  }

  toBase64(file, type, cb) {
    const blob = new Blob(file, type)
    const reader = new FileReader()
    reader.onloadend = () => {
      cb(reader.result)
      this.loading = false
      this.show = false
      this.$emit('displayed')
    }
    reader.readAsDataURL(blob)
  }

  normalizeRotation(doc) {
    if (doc.page.pdfPageRotate > 0) {
      this.rotation = doc.page.pdfPageRotate * -1
    }
  }

  nextPage() {
    if (this.curPage < this.totalsPages) this.curPage++
  }

  prevPage() {
    if (this.curPage > 1) this.curPage--
  }

  async getFile() {
    this.loading = true
    if (this.type === 'pdf') {
      this.pdfLoaded = false
      this.rotation = 0
      this.curPage = 1
    }
    if (this.fileForPreview) {
      if (this.type === 'pdf') {
        this.toBase64([this.fileForPreview], { type: 'application/pdf' }, (base64) => {
          this.pdf = base64
          this.errorPdf = false
          this.pdfLoaded = true
        })
      } else {
        this.image = this.fileForPreview;
        this.loading = false
      }
      return
    }
    try {
      if (this.id && !this.changeFile) {
        const { data } = await this.digitalPost.getFile(this.id, this.type)
        if (this.type === 'pdf') {
          this.toBase64([data], { type: 'application/pdf' }, (base64) => {
            this.pdf = base64
            this.errorPdf = false
            this.pdfLoaded = true
          })
        } else {
          this.toBase64([data], { type: `image/${this.type}` }, (base64) => {
            this.errorImg = false
            this.image = base64
          })
        }
      }
      return
    } catch (e) {
      if (this.type == 'pdf') this.errorPdf = true
      else this.errorImg = true
      this.loading = false
    }
  }
}
